<template>
  <el-row style="padding: 20px 0px;">
    <el-col :offset="1" :span="5">
      <el-button v-show="backLink != ''" @click="goBack" style="float: left" type="primary" icon="el-icon-back">{{ $t('common.back') }}</el-button>
    </el-col>
    <div v-if="backLink !== ''">
      <el-col :span="12">
        <h2>{{ $t(title) }}</h2>
      </el-col>
    </div>
    <div v-else>
      <el-col :offset="6" :span="12">
        <h2>{{ $t(title) }}</h2>
      </el-col>
    </div>
  </el-row>
</template>

<script>
  export default {
    name: "PageTitle",
    props: ['title', 'backLink'],
    methods: {
      goBack: function () {
        this.$router.push(this.backLink)
      }
    }
  }
</script>

<style scoped>

</style>